import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TrustHtmlPipe } from '../../pipes/trust-html.pipe';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TrustHtmlPipe],
})
export class AlertComponent {
  readonly text = input<string | string[]>('');
  readonly type = input('');
  readonly title = input('');
  readonly dismissableButton = input<boolean>();
  /**
   * How a screen reader announces it. `alert` interrupts; `status` waits its turn - for a message
   * that sits beside another alert which already interrupted.
   */
  readonly alertRole = input<'alert' | 'status'>('alert');

  protected readonly alertType = computed(() => this.type() || 'success');
  protected readonly messages = computed(() => {
    const text = this.text();
    return Array.isArray(text) ? text : undefined;
  });
}
